// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xkNCc","active":"styles_active__BqD5U","edit":"styles_edit__mXgOH","label":"styles_label__TTWz9","placeholder":"styles_placeholder__52nZF"};